module.exports = "<ng-content></ng-content>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/post-item/widget/widget.component.html
// module id = ../../../../../src/app/post-item/widget/widget.component.html
// module chunks = main